import { render, staticRenderFns } from "./vsDropDownGroup.vue?vue&type=template&id=4ec54ab7&lang=html&"
import script from "./vsDropDownGroup.vue?vue&type=script&lang=js&"
export * from "./vsDropDownGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsDropDownGroup.vue"
export default component.exports